import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { VideoLessonItem } from "../../../Pages/UserVideoLessonDetail/ILessonsList";

// 👇 Combine the interfaces to represent a full video Topic item
export type IVideoTopic = any;

export const LikeDiscussionVideoLessonsSlice = createSlice({
  name: "LikeDiscussionVideoLessonsSlice",
  initialState: {} as IReduxState<IVideoTopic>,
  reducers: {
    LikeDiscussionVideoLesson: (state, action) => {
      // state.isLoading = true;
      state.isLoading = false;
    },

    successLikeDiscussionVideoLessons: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureLikeDiscussionVideoLessons: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  LikeDiscussionVideoLesson,
  successLikeDiscussionVideoLessons,
  failureLikeDiscussionVideoLessons,
} = LikeDiscussionVideoLessonsSlice.actions;

export default LikeDiscussionVideoLessonsSlice.reducer;
